<template>
    <div class="box" :class="{ 'box-bg': !bgColor }" :style="{
        background: bgColor,
    }">
        <img class="logo" src="../assets/logo.webp" />
        <div class="btns">
            <div class="btn" v-for="btn in btns" :key="btn.name" @click="handleClick(btn.path)" :style="{
                color: btn.name === cur ? '#186DFF' : '#333',
                background: btn.name === cur ? 'rgba(24, 109, 255, .16)' : '#fff',
            }">
                {{ btn.name }}
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps } from "vue";
import { useRouter } from "vue-router";
defineProps({
    cur: {
        type: String,
        required: true,
        default: "Home",
    },
    bgColor: {
        type: String,
    },
});
const router = useRouter();
const btns = [
    {
        name: "Home",
        path: "/",
    },
    {
        name: "Services",
        path: "/service",
    },
    {
        name: "About US",
        path: "/about",
    },
    {
        name: "Legality",
        path: "/legality",
    },
    {
        name: "Contact US",
        path: "/contact",
    },
    {
        name: "Privacy Policy",
        path: "/privatePolicy",
    },
    {
        name: "Loan Agreement",
        path: "/loanAgreement",
    },
];
const handleClick = (path) => {
    console.log("path", path);
    router.replace(path);
};
</script>
<style lang="less" scoped>
.box {
    height: 77px;
    padding: 0 116px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;

    .logo {
        width: 250px;
        object-fit: contain;
    }

    .btns {
        display: flex;

        .btn {
            margin-right: 10px;
            font-weight: bold;
            font-size: 11px;
            cursor: pointer;
            border-radius: 16px;
            padding: 7px;
            text-wrap: nowrap;  
        }
    }
}

.box-bg {
    background-image: url("../assets/headerBg.webp");
    background-size: 100% 100%;
}
</style>